<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.92598 20.4486L9.30821 21.1632V22.25H2V21.1632L4.38223 20.4486V3.55138L2 2.8219V1.75H9.30821V2.8219L6.92598 3.55138V20.4486ZM19.6178 20.4486L22 21.1632V22.25H14.6918V21.1632L17.074 20.4486V3.55138L14.6918 2.8219V1.75H22V2.8219L19.6178 3.55138V20.4486ZM5.40511 12.7369V10.876H18.5949V12.7369H5.40511Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default { name: 'Headline' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
